import { EventNotificationsService } from '@common/ApiService'

const CANCEL_SUCCESS = 'CANCEL_SUCCESS'
const CREATE_SUCCESS = 'CREATE_SUCCESS'
const ERROR = 'ERROR'
const INDEX_SUCCESS = 'INDEX_SUCCESS'
const SHOW_SUCCESS = 'SHOW_SUCCESS'
const UPDATE_SUCCESS = 'UPDATE_SUCCESS'

export const state = {
  notification: {},
  notifications: [],
}

export const getters = {
  notificationsCount(state) {
    return state.notifications.length
  },
}

function updateNotifications(data) {
  let newArray = state.notifications.filter(
    (notification) => notification.id !== data.id
  )
  newArray.push(data)
  newArray.sort((a, b) => {
    const dateA = Date.parse(a.trigger_at)
    const dateB = Date.parse(b.trigger_at)
    return dateA - dateB
  })
  return newArray
}

export const mutations = {
  [CANCEL_SUCCESS](state, data) {
    state.notification = data
    state.notifications = updateNotifications(data)
  },
  [CREATE_SUCCESS](state, data) {
    state.notification = data
    state.notifications = updateNotifications(data)
  },
  [ERROR](state, data) {
    state.error = data
  },
  [INDEX_SUCCESS](state, data) {
    state.notifications = data
  },
  [SHOW_SUCCESS](state, data) {
    state.notification = data
  },
  [UPDATE_SUCCESS](state, data) {
    state.notification = data
    state.notifications = updateNotifications(data)
  },
}

export const actions = {
  cancel({ commit }, id) {
    return EventNotificationsService.cancel(id)
      .then((response) => {
        commit(CANCEL_SUCCESS, response.data)
        return response.data
      })
      .catch((error) => {
        commit(ERROR, error.response)
        return error.response.data
      })
  },
  create({ commit }, params) {
    return EventNotificationsService.create(params)
      .then((response) => {
        commit(CREATE_SUCCESS, response.data)
        return response.data
      })
      .catch((error) => {
        commit(ERROR, error.response)
        return error.response.data
      })
  },
  get({ commit }, id) {
    return EventNotificationsService.get(id)
      .then((response) => {
        commit(SHOW_SUCCESS, response.data)
        return response.data
      })
      .catch((error) => {
        commit(ERROR, error.response)
        return error.response.data
      })
  },
  index({ commit }, params) {
    return EventNotificationsService.index(params)
      .then((response) => {
        commit(INDEX_SUCCESS, response.data)
        return response.data
      })
      .catch((error) => {
        commit(ERROR, error.response)
        return error.response.data
      })
  },
  update({ commit }, params) {
    return EventNotificationsService.update(params.id, params)
      .then((response) => {
        commit(UPDATE_SUCCESS, response.data)
        return response.data
      })
      .catch((error) => {
        commit(ERROR, error.response)
        return error.response.data
      })
  },
}
